import { render, staticRenderFns } from "./applicationOldList.vue?vue&type=template&id=2a8fa056&scoped=true&"
import script from "./applicationOldList.vue?vue&type=script&lang=js&"
export * from "./applicationOldList.vue?vue&type=script&lang=js&"
import style0 from "./applicationOldList.vue?vue&type=style&index=0&id=2a8fa056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8fa056",
  null
  
)

export default component.exports